import { Language } from '../constants/languages';
export const STEPPER_KEYS = ['ArrowUp', 'ArrowDown'];
export const DEFAULT_DECIMAL_SEPARATOR = '.';
export const DEFAULT_THOUSANDS_SEPARATOR = ',';
export const HOLD_THRESHOLD = 25;
export const STEPPING_INTERVAL_TIME = 16;
export const NUMBER_FIELD_TRANSLATION_KEYS = {
  accessibleStepDownLabel: 'component.NumberField.accessibleStepDownLabel',
  accessibleStepUpLabel: 'component.NumberField.accessibleStepUpLabel'
};
export const NUMBER_FIELD_TRANSLATIONS = {
  [Language.EN]: {
    [NUMBER_FIELD_TRANSLATION_KEYS.accessibleStepDownLabel]: _ref => {
      let {
        step
      } = _ref;
      return `Decrease value by ${step}`;
    },
    [NUMBER_FIELD_TRANSLATION_KEYS.accessibleStepUpLabel]: _ref2 => {
      let {
        step
      } = _ref2;
      return `Increase value by ${step}`;
    }
  },
  [Language.PL]: {
    [NUMBER_FIELD_TRANSLATION_KEYS.accessibleStepDownLabel]: _ref3 => {
      let {
        step
      } = _ref3;
      return `Zmniejsz wartość o ${step}`;
    },
    [NUMBER_FIELD_TRANSLATION_KEYS.accessibleStepUpLabel]: _ref4 => {
      let {
        step
      } = _ref4;
      return `Zwiększ wartość o ${step}`;
    }
  },
  [Language.CS]: {
    [NUMBER_FIELD_TRANSLATION_KEYS.accessibleStepDownLabel]: _ref5 => {
      let {
        step
      } = _ref5;
      return `Snižte hodnotu o ${step}`;
    },
    [NUMBER_FIELD_TRANSLATION_KEYS.accessibleStepUpLabel]: _ref6 => {
      let {
        step
      } = _ref6;
      return `Zvyšte hodnotu o ${step}`;
    }
  },
  [Language.SK]: {
    [NUMBER_FIELD_TRANSLATION_KEYS.accessibleStepDownLabel]: _ref7 => {
      let {
        step
      } = _ref7;
      return `Znížte hodnotu o ${step}`;
    },
    [NUMBER_FIELD_TRANSLATION_KEYS.accessibleStepUpLabel]: _ref8 => {
      let {
        step
      } = _ref8;
      return `Zvýšte hodnotu o ${step}`;
    }
  }
};